import { createContext, useContext } from 'react';

export type LeftSidebarContextValue = {
    isOpen: boolean;
    toggle: () => void;
};

export const LeftSidebarContext = createContext<
    LeftSidebarContextValue | undefined
>(undefined);

export const useLeftSidebar = () => useContext(LeftSidebarContext);
